import { useMemo } from "react";
import { useSelector } from "react-redux";
import AED from "icons/AED";
import { TranslationText } from "./TextTranslationContainer";
import { getDiscount } from "utils/discounts.utils";
import { calculateItemDiscount } from "utils/discounts.utils";

export const PriceRender = ({
  price = 0,
  className = "text-16x leading-none",
  currencySymbolClassName = "text-brand-base-primary",
}) => {
  let size = 16; // default size
  if (className?.includes("text-")) {
    const match = className.match(/text-(\d+)x/);
    if (match) {
      size = parseInt(match[1], 10);
    }
  }

  return (
    <div className={`m-0 flex items-center gap-1 `}>
      <AED
        className={currencySymbolClassName}
        width={size - 2}
        height={size - 2}
      />
      <span className={`${className}`}>{price?.toFixed(2)}</span>
    </div>
  );
};

export const RenderTotalPrice = ({
  total = 0,
  title = "Total (inc. Tax)",
  showDivider = true,
}) => {
  return (
    <>
      <div className="flex justify-between items-center text-16x w-full font-bold">
        <TranslationText text={title} />
        <PriceRender price={total} className="dummy-class leading-none" />
      </div>
      {showDivider && <hr className="border-t-2 w-full my-4" />}
    </>
  );
};

export const RenderDiscountedPrice = ({
  price = {
    discountedPrice: 0,
    actualPrice: 0,
    discountAmount: 0,
    discountType: 0,
  },
  className = "text-16x leading-none",
  currencySymbolClassName = "text-brand-base-primary",
}) => {
  return (
    <div
      className="flex gap-2 items-center flex-wrap"
      // style={{
      //   alignItems: "baseline",
      // }}
    >
      {price?.discountedPrice > 0 && (
        <PriceRender
          className={`${
            className ?? "text-16x "
          } text-red-500 font-bold leading-none`}
          price={price?.discountedPrice}
          currencySymbolClassName={currencySymbolClassName}
        />
      )}
      <PriceRender
        className={`text-brand-base-primary font-bold leading-none ${
          className ?? "text-16x"
        } ${price.discountedPrice ? "line-through" : ""}`}
        price={price?.actualPrice}
        currencySymbolClassName={currencySymbolClassName}
      />
      {price?.discountAmount && (
        <div
          className={`flex items-center gap-1 ${
            className ?? "text-16x"
          } text-red-500 font-bold leading-none`}
        >
          <span>On Sale: {price?.discountAmount}</span>
          {price?.discountType?.toLowerCase() === "percentage" ? (
            <span>%</span>
          ) : (
            <AED className={"text-red-500"} width={14} height={14} />
          )}
        </div>
      )}
    </div>
  );
};

const DisplayPrice = ({ item, className, currencySymbolClassName }) => {
  const { selectedStore: store } = useSelector((state) => state.store);
  const { discounts } = useSelector((state) => state?.brand);
  const { orderType } = useSelector((state) => state?.AppReducer);

  const price = useMemo(() => {
    const actualPrice = item?.price;
    let discountedPrice = 0;
    const discount = getDiscount({ discounts, item, storeId: store?._id, orderType: orderType?.serviceType });
    
    if (!discount) return { actualPrice, discountedPrice };
    discountedPrice = calculateItemDiscount(discount, actualPrice);
   
    return {
      actualPrice,
      discountedPrice,
      ...{
        discountAmount: discount?.discountAmount,
        discountType: discount?.discountType,
      },
    };
  }, [item, discounts]);

  return (
    <RenderDiscountedPrice
      price={price}
      className={className}
      currencySymbolClassName={currencySymbolClassName}
    />
  );
};
export default DisplayPrice;
